const cvData = {
  personal: {
    name: "Clément Girault",
    email: "clement.girault@icloud.com",
    phone: "+61 431 945 020",
    location: "Potts Point, NSW, 2011, Australia",
    website: "https://clement.girau.lt/",
    linkedin: "https://www.linkedin.com/in/clementgirault/",
  },

  summary:
    "I work at the intersection of technology, design and organisational change, helping complex organisations turn digital ambition into practical, scalable outcomes. Across more than 20 years in government, education, research and not-for-profit environments, I’ve led digital platforms, service design programs and technology transformations from discovery through to delivery. I combine senior strategy and stakeholder leadership with hands-on capability across software, systems architecture, UX and explainable AI—and I’m motivated by using technology thoughtfully in the public interest.",

  experience: [
    {
      title: "Lecturer",
      company: "The University of Sydney, Sydney College of the Arts",
      location: "Sydney, Australia",
      startDate: "2026",
      endDate: "Ongoing",
      displayDate: "2026 - Ongoing",
      responsibilities: [
        "Lecturing Digital Effects for Film and Video. Delivering conceptual and practical instruction in motion graphics and digital effects for film and video. Teaching Adobe After Effects workflows spanning typography, masking, animation, compositing, visual effects and sound.",
      ],
    },
    {
      title: "Freelancer",
      company: "Thinking Out",
      location: "Sydney, Australia",
      startDate: "07/2010",
      endDate: "Present",
      responsibilities: [
        "Delivering digital strategy, service design and technical solutions for government, NGO and private clients, including The Monthly / Slow TV, Mulong, Firesticks Project, Street Furniture Australia, Jumbunna Indigenous House of Learning and the NSW Department of Education.",
        "Work spans websites and applications for mobile and desktop, with video footage screened on ABC, SBS, BBC and M6.",
        "Created compelling digital content including video production, compositing, and sound design.",
        "Provided mentoring and consultancy on projects related to First Nations traditional knowledge.",
      ],
    },
    {
      title: "Senior Digital Officer / Digital Team Lead",
      company: "Garvan Institute of Medical Research",
      location: "Sydney, Australia",
      startDate: "05/2021",
      endDate: "03/2023",
      responsibilities: [
        "Spearheaded the management of CMS, DAM, CRM, and EDM platforms, overseeing a comprehensive tech stack overhaul and MACH-based website redevelopment: https://garvan.org.au",
        "Executed future-proof integrations using GraphQL APIs, facilitating external data sourcing and platform growth.",
        "Implemented automations that enhanced operational efficiency and reduced workloads.",
        "Formulated business cases and conducted financial analyses to underpin digital investments.",
        "Conducted UX research, workshops and interviews. Designed prototypes.",
        "Cultivated stakeholder relationships and orchestrated content strategies to ensure alignment with organisational goals.",
      ],
    },
    {
      title: "Digital Media Specialist",
      company: "NSW Department of Education",
      location: "Sydney, Australia",
      startDate: "07/2019",
      endDate: "03/2020",
      responsibilities: [
        "Engineered and developed a cross-platform application prototype using Power Apps to enhance communication between curriculum advisors and teachers.",
        "Optimised workflows with Power Automate, boosting efficiency and minimising administrative overhead.",
        "Supported the transition from Squiz Matrix to Adobe Experience Manager, ensuring continuity and compliance with accessibility standards.",
      ],
    },
    {
      title: "Senior Digital Communications Advisor",
      company: "Department of Finance, Services & Innovation",
      location: "Sydney, Australia",
      startDate: "10/2018",
      endDate: "02/2019",
      responsibilities: [
        "Directed a website redevelopment project, enhancing usability and accessibility.",
        "Provided strategic guidance on digital communications and instituted analytics frameworks for policy evaluation.",
        "Managed publishing platforms and procedures for effective content delivery.",
      ],
    },
    {
      title: "Senior Communications Officer (Digital Strategy)",
      company: "NSW Public Service Commission",
      location: "Sydney, Australia",
      startDate: "11/2017",
      endDate: "02/2018",
      profileResponsibilityCount: 3,
      responsibilities: [
        "Coordinated digital projects across internal teams and external suppliers.",
        "Facilitated the redevelopment of front-end and back-end components of the website.",
        "Advised on WCAG accessibility, communication strategy and branding.",
      ],
    },
    {
      title: "Senior Communications & Stakeholder Engagement Officer",
      company: "Transport for NSW",
      location: "Sydney, Australia",
      startDate: "08/2016",
      endDate: "10/2017",
      responsibilities: [
        "Formulated stakeholder adoption strategies and engagement plans.",
        "Instituted a Salesforce-based CRM system to monitor stakeholder interactions.",
        "Researched and authored ministerial briefs, talking points, and strategic reports.",
      ],
    },
    {
      title: "Project Officer, Indigenous Services",
      company: "State Library of NSW",
      location: "Sydney, Australia",
      startDate: "06/2015",
      endDate: "04/2016",
      responsibilities: [
        "Developed Drupal-based CMS and Digital Asset Management prototypes.",
        "Assisted with UX/UI design initiatives for Indigenous community project websites.",
        "Provided detailed reporting and facilitated stakeholder engagement activities.",
      ],
    },
    {
      title: "Lecturer & Screen Media Production Manager",
      company: "University of Technology Sydney",
      location: "Sydney, Australia",
      startDate: "03/2004",
      endDate: "03/2015",
      responsibilities: [
        "Coordinated and instructed video media and motion graphics subjects over an eight-year tenure.",
        "Managed media facilities and resources, including the implementation of a Ruby on Rails-based equipment booking system.",
        "Championed community outreach initiatives to foster student and community engagement.",
      ],
    },
  ],

  education: [
    {
      degree: "PhD in Sociology and Social Policy (discontinued)",
      institution: "The University of Sydney",
      location: "Sydney, Australia",
      startDate: "2010",
      endDate: "2012",
      details: [
        "Thesis: Revolutions Per Minute — The political economy of Australian music in the age of digital reproduction.",
        "Completed literature review and ethics approval; conducted field interviews and began thesis write-up.",
      ],
    },
    {
      degree: "Bachelor of Arts (Honours) in Communication",
      institution: "University of Technology Sydney",
      location: "Sydney, Australia",
      startDate: "1999",
      endDate: "2000",
      details: [
        "Thesis awarded High Distinction.",
        "Thesis: The death of the author — a fictocritical post-structuralist detective story.",
      ],
    },
    {
      degree: "Bachelor of Arts in Communication",
      institution: "University of Technology Sydney",
      location: "Sydney, Australia",
      startDate: "1996",
      endDate: "1999",
      details: [
        "Majors: Communication/Sound/Image, Film and Video, Cultural Studies.",
      ],
    },
    {
      degree: "Baccalauréat A1 in Philosophy and Mathematics",
      institution: "Lycée Saint Martin de France",
      location: "Paris, France",
      startDate: "1994",
      endDate: "1994",
      details: [],
    },
  ],

  skills: [
    // Strategy & Management
    "Project management",
    "Service design",
    "Strategic consulting",
    "Digital strategy",
    "Problem solving",
    "Digital workflow automation",
    "Stakeholder engagement",
    "Stakeholder communication",
    "Change management",
    "Risk assessment",
    "Policy analysis",
    "Needs analysis",
    // UX & Design
    "UX/UI design",
    "User research",
    "Information architecture",
    "Content strategy",
    // Technical
    "Platform integration",
    "Platform migration",
    "Machine Learning",
    "Gen AI",
    "Agentic AI",
    "GraphQL APIs",
    "SEO",
    "SEM",
    "Microsoft Power Platform",
    "Marketing automation",
    "Optimisation",
    "WCAG",
    "Analytics",
    // Programming
    "C#",
    "C++",
    "HTML/CSS/SCSS",
    "Javascript",
    "Python",
    "Swift/Swift UI",
    "React",
    // Other
    "Agile methodologies",
    "Mentoring/Teaching",
    "Learning design",
    "Application development",
    "Media production",
    "Cultural heritage",
    "Reporting",
  ],

  languages: [
    { language: "English", level: "Native", proficiency: 5 },
    { language: "French", level: "Native", proficiency: 5 },
    { language: "Spanish", level: "Solid", proficiency: 3 },
    { language: "Hindi", level: "Beginner", proficiency: 1 },
  ],
};

export default cvData;
